import React, { useEffect, useState } from 'react';
import { useStaticQuery, graphql } from 'gatsby'

import JobBoardItem from './JobBoardItem';

const JobBoard = () => {
  const sponsorsQuery = useStaticQuery(graphql`
    query {
      allBuilderModels {
        sponsors (
          options: {
            cachebust: true
          }
        ) {
          id
          content
        }
        sponsorshipLevels (
          options: {
            cachebust: true
          }
        ) {
          id
          name
        }
      }
    }
  `);

  const [jobsList, setJobsList] = useState([]);

  useEffect(() => {
    if (!sponsorsQuery) {
      return;
    }

    setJobsList(sponsorsQuery.allBuilderModels.sponsors
      .filter((s) => !!s.content.data.jobBoard)
      .map((s) => {
        return { id: s.id, ...s.content.data };
      })
    );

  }, [sponsorsQuery]);

  return (
    <div
      id='rs-blog'
      className='rs-blog blog-main-home home-6-blog-style bg27'
    >
      <div className='container'>
        <div>
          {jobsList.map((sponsor) => (
            <JobBoardItem
              key={sponsor.id}
              sponsor={sponsor}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default JobBoard;
